/* ETOM design – detail motorky (sekce etom-product-*). Bez závislostí, načítá se s defer. */
(function () {
  'use strict';

  /* ---------- Hlavní blok: varianty, galerie, sticky lišta ---------- */
  document.querySelectorAll('[data-etom-pdp]').forEach(function (root) {
    var dataEl = root.querySelector('[data-etom-product]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var form = root.querySelector('.etom-pdp__form');
    var idInput = root.querySelector('[data-etom-variant-id]');
    var fieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-etom-option]'));
    var priceEls = root.querySelectorAll('[data-etom-price], [data-etom-sticky-price]');
    var stockEl = root.querySelector('[data-etom-stock]');
    var stockText = root.querySelector('[data-etom-stock-text]');
    var addBtns = root.querySelectorAll('[data-etom-add]');
    var mainImg = root.querySelector('.etom-pdp__main-img');
    var stickyMeta = root.querySelector('[data-etom-sticky-meta]');

    function selected() {
      return fieldsets.map(function (fs) {
        var b = fs.querySelector('[aria-pressed="true"]');
        return b ? b.dataset.value : null;
      });
    }

    function findVariant(opts) {
      return data.variants.find(function (v) {
        return opts.every(function (o, i) { return o === null || v.options[i] === o; });
      });
    }

    function render(v) {
      if (!v) return;
      idInput.value = v.id;
      priceEls.forEach(function (el) { el.innerHTML = v.price; });
      /* převodník měn Bucks: po přepsání ceny znovu přepočítat do zvolené měny */
      if (window.bucksCC && typeof window.bucksCC.reConvert === 'function') {
        try { window.bucksCC.reConvert(); } catch (e) {}
      }
      addBtns.forEach(function (b) { b.disabled = !v.available; });
      var label = root.querySelector('.etom-pdp__panel [data-etom-add]');
      if (label) label.textContent = v.available ? 'Přidat do košíku' : 'Vyprodáno';
      if (stockEl && stockText) {
        stockEl.querySelector('.etom-pdp__stock-line').classList.toggle('is-order', !v.inStock);
        stockText.innerHTML = v.inStock ? data.stockText + data.stockLead : data.orderText + data.orderLead;
      }
      if (mainImg && v.mediaSrc) {
        if (typeof showMedia === 'function' && root.querySelector('[data-etom-thumb][data-media-id="' + v.media + '"]')) {
          showMedia(v.media);
        } else {
          mainImg.removeAttribute('srcset');
          mainImg.src = v.mediaSrc;
          mainImg.closest('[data-media-id]').dataset.mediaId = v.media;
        }
      }
      /* mobil: posunout pás fotek na fotku varianty */
      var swipeEl = root.querySelector('[data-etom-swipe]');
      if (swipeEl && v.media) {
        var slide = swipeEl.querySelector('.etom-pdp__slide[data-media-id="' + v.media + '"]');
        if (slide) {
          /* okamžitě – plynulé posouvání se u pásu s přichytáváním (scroll-snap) občas přeruší */
          swipeEl.scrollLeft = slide.offsetLeft - swipeEl.offsetLeft;
        }
      }
      if (stickyMeta) {
        stickyMeta.textContent = v.options.join(' · ') + ' · ' + (v.inStock ? 'skladem' : 'na objednávku');
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    fieldsets.forEach(function (fs) {
      fs.addEventListener('click', function (e) {
        var btn = e.target.closest('button[data-value]');
        if (!btn) return;
        fs.querySelectorAll('button[data-value]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        var lbl = fs.querySelector('[data-etom-option-label]');
        if (lbl) lbl.textContent = btn.dataset.value;
        var opts = selected();
        var v = findVariant(opts);
        if (!v) {
          /* kombinace neexistuje – vezmi první variantu s touto hodnotou */
          var idx = fieldsets.indexOf(fs);
          v = data.variants.find(function (x) { return x.options[idx] === btn.dataset.value; });
          if (v) fieldsets.forEach(function (f, i) {
            f.querySelectorAll('button[data-value]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.value === v.options[i] ? 'true' : 'false'); });
            var l = f.querySelector('[data-etom-option-label]'); if (l) l.textContent = v.options[i];
          });
        }
        render(v);
      });
    });
    /* Desktop galerie – svislé náhledy vedle hlavní fotky */
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-etom-thumb]'));
    var mainBtn = root.querySelector('.etom-pdp__main-media');
    function showMedia(id) {
      var t = thumbs.find(function (x) { return x.dataset.mediaId === String(id); });
      if (!t || !mainImg) return;
      thumbs.forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
      mainImg.removeAttribute('srcset');
      mainImg.src = t.dataset.src;
      mainImg.alt = t.dataset.alt;
      if (mainBtn) mainBtn.dataset.mediaId = t.dataset.mediaId;
      t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    function stepMedia(dir) {
      var i = thumbs.findIndex(function (x) { return x.getAttribute('aria-current') === 'true'; });
      var n = thumbs[(i + dir + thumbs.length) % thumbs.length];
      if (n) showMedia(n.dataset.mediaId);
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.mediaId); }); });
    var prev = root.querySelector('[data-etom-thumb-prev]');
    var next = root.querySelector('[data-etom-thumb-next]');
    if (prev) prev.addEventListener('click', function () { stepMedia(-1); });
    if (next) next.addEventListener('click', function () { stepMedia(1); });

    render(findVariant(selected()));

    /* Mobilní galerie – indikátor */
    var swipe = root.querySelector('[data-etom-swipe]');
    if (swipe) {
      var dots = root.querySelectorAll('.etom-pdp__dot');
      swipe.addEventListener('scroll', function () {
        var i = Math.round(swipe.scrollLeft / swipe.clientWidth);
        dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
      }, { passive: true });
    }

    /* Lightbox */
    var lb = root.querySelector('[data-etom-lightbox]');
    if (lb && typeof lb.showModal === 'function') {
      root.querySelectorAll('[data-etom-lightbox-open]').forEach(function (b) {
        b.addEventListener('click', function () {
          lb.showModal();
          var target = lb.querySelector('#EtomLb-' + root.dataset.section + '-' + b.dataset.mediaId);
          if (target) target.scrollIntoView({ block: 'nearest', inline: 'start' });
        });
      });
      lb.querySelector('[data-etom-lightbox-close]').addEventListener('click', function () { lb.close(); });
      lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
    }

    /* Plovoucí lišta po odscrollování z nákupního panelu */
    var sticky = root.querySelector('[data-etom-sticky]');
    var panel = root.querySelector('[data-etom-add]');
    if (sticky && panel && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
      }).observe(panel);
    }
  });

  /* ---------- Převodník měn Bucks: přesunout z rohu obrazovky k ceně ---------- */
  var currencySlot = document.querySelector('[data-etom-currency]');
  if (currencySlot) {
    var placeBucks = function () {
      var w = document.querySelector('.buckscc-currency-wrapper');
      if (w && w.parentElement !== currencySlot) {
        currencySlot.appendChild(w);
        currencySlot.classList.add('is-ready');
      }
    };
    placeBucks();
    if ('MutationObserver' in window) {
      /* Bucks se načítá asynchronně a widget může znovu vykreslit */
      new MutationObserver(placeBucks).observe(document.body, { childList: true });
    }
  }

  /* ---------- Accordion (FAQ, obrázek se záložkami) ---------- */
  document.querySelectorAll('[data-etom-acc]').forEach(function (acc) {
    var single = acc.hasAttribute('data-etom-acc-single');
    acc.addEventListener('click', function (e) {
      var btn = e.target.closest('.etom-acc__btn');
      if (!btn || !acc.contains(btn)) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      if (single && open) return;
      if (single) {
        acc.querySelectorAll('.etom-acc__btn').forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          document.getElementById(b.getAttribute('aria-controls')).hidden = true;
        });
      }
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      document.getElementById(btn.getAttribute('aria-controls')).hidden = open;
      var media = acc.closest('[data-etom-tabs-media]');
      if (media && !open) {
        var key = btn.dataset.media;
        media.querySelectorAll('[data-etom-tab-img]').forEach(function (img) { img.hidden = img.dataset.etomTabImg !== key; });
      }
    });
  });

  /* ---------- Zkrácený text (popis na mobilu) ---------- */
  document.querySelectorAll('[data-etom-clamp]').forEach(function (box) {
    var content = box.querySelector('.etom-clamp__content');
    var btn = box.querySelector('.etom-clamp__toggle');
    if (!content || !btn) return;
    function check() {
      if (box.classList.contains('is-open')) return;
      btn.hidden = content.scrollHeight <= content.clientHeight + 4;
      box.classList.toggle('is-clamped', !btn.hidden);
    }
    btn.addEventListener('click', function () {
      var open = box.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Zobrazit méně' : 'Zobrazit více';
      if (!open) box.scrollIntoView({ block: 'nearest' });
    });
    check();
    window.addEventListener('resize', check, { passive: true });
  });

  /* ---------- Přepínač (dojezd podle úrovně jezdce) ---------- */
  document.querySelectorAll('[data-etom-segment]').forEach(function (list) {
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    list.addEventListener('click', function (e) {
      var t = e.target.closest('[role="tab"]');
      if (t) select(t);
    });
    list.addEventListener('keydown', function (e) {
      var i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); select(tabs[(i + 1) % tabs.length], true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); select(tabs[(i - 1 + tabs.length) % tabs.length], true); }
    });
  });

  /* ---------- Poptávka jiné výbavy: zaškrtnuté volby do zprávy ---------- */
  document.querySelectorAll('[data-etom-config-form]').forEach(function (wrap) {
    var f = wrap.querySelector('form');
    if (!f) return;
    f.addEventListener('submit', function () {
      var picked = Array.prototype.map.call(f.querySelectorAll('input[data-etom-config]:checked'), function (c) { return c.value; });
      var hidden = f.querySelector('[data-etom-config-out]');
      if (hidden) hidden.value = picked.length ? picked.join(', ') : 'beze změn výbavy';
      var vOut = f.querySelector('[data-etom-variant-out]');
      var sel = Array.prototype.map.call(document.querySelectorAll('[data-etom-option] [aria-pressed="true"]'), function (b) { return b.dataset.value; });
      if (vOut && sel.length) vOut.value = sel.join(' / ');
    });
    var toggle = wrap.querySelector('[data-etom-config-toggle]');
    if (toggle) toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      f.classList.toggle('is-open', !open);
    });
  });

  /* ---------- Rychlé přidání doplňku do košíku ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-etom-quick-add]');
    if (!f || !window.fetch) return;
    e.preventDefault();
    var btn = f.querySelector('button');
    btn.disabled = true;
    fetch(f.action.replace(/\/$/, '') + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(function (r) { if (!r.ok) throw r; btn.textContent = 'Přidáno ✓'; document.dispatchEvent(new CustomEvent('etom:cart-updated')); })
      .catch(function () { f.submit(); });
  });

  /* ---------- K motorce se hodí: custom.doplnky, jinak doplňkové produkty Shopify ---------- */
  document.querySelectorAll('[data-etom-recs]').forEach(function (box) {
    if (box.dataset.manual === 'true') return;
    var url = box.dataset.url + '&intent=complementary';
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      /* jen doplňkové produkty (Search & Discovery) – „podobné“ by nabídly jiné motorky a půjčovny */
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var cards = doc.querySelector('[data-etom-recs-cards]');
      return cards && cards.children.length ? cards.innerHTML : '';
    }).then(function (inner) {
      var target = box.querySelector('[data-etom-recs-cards]');
      if (inner) { target.innerHTML = inner; box.hidden = false; }
    }).catch(function () {});
  });
})();
